/***
 *
 *   HEADER STYLES
 *   Ported from ui-reference/src/components/layouts/top-bar.tsx.
 *
 *   `h-16` at the reference's 14px root is 56px, not 64px, and matches the
 *   sidebar's own top slot so the two rows line up.
 *
 **********/

const Style = {
    header: `sticky top-0 z-30 flex h-16 w-full min-w-0 shrink-0 items-center gap-x-4
    border-b bg-surface/80 px-4 backdrop-blur-sm md:px-6`,

    leading: 'flex min-w-0 flex-1 items-center gap-2',

    // md and up only: below that the sidebar is hidden and the mobile bottom bar
    // takes over, so there is nothing to collapse.
    toggleTooltip: 'hidden md:inline-flex',
    toggle: `inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-border
    bg-surface text-text-secondary transition-colors hover:bg-muted hover:text-text-primary
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2`,

    // `[-webkit-overflow-scrolling:touch]` is the reference's; it keeps the tab
    // rail from rubber-banding the page on iOS.
    tabs: 'hidden min-w-0 flex-1 overflow-x-auto overscroll-x-contain md:block [-webkit-overflow-scrolling:touch]',

    trailing: 'ml-auto flex shrink-0 items-center gap-2 md:gap-3',
    identity: 'flex shrink-0 items-center gap-2 md:gap-3',
    identityDivided: 'border-l border-border pl-2 md:pl-3',
};

export default Style;
